import { Box, Flex, Heading, ModalBody, ModalFooter, ModalHeader, VStack } from '@chakra-ui/react';
import { BaseModal } from './BaseModal';
import MaskImage from '../../assets/img/WhiteMaskBg.png';
import { RippleBackBtn } from '../Buttons/RippleBackBtn';
import { useTranslation } from 'react-i18next';
import { RadarChart } from '../User/RadarChart';
import { CardWithShadow } from '../User/CardWithShadow';
import { RADAR_LINES } from '../../data/scoreRadar';
import { ScoreCard } from '../User/ScoreCard';

interface IMemberQrCode {
  isOpen: boolean;
  onClose: VoidFunction;
  score: (number | string)[];
  firstName: string;
  lastName: string;
}

export const MemberScoreModal = (props: IMemberQrCode) => {
  const { t } = useTranslation();
  const { firstName, lastName, isOpen, onClose, score } = props;

  return (
    <BaseModal
      isOpen={isOpen}
      size='full'
      contentProps={{
        sx: {
          background: `url(${MaskImage}) bottom right no-repeat, #fff`,
          overflow: 'auto',
        },
      }}
    >
      <ModalHeader
        fontSize={{ base: '5xl', lg: '6xl' }}
        fontWeight={400}
        fontStyle='italic'
        mt={0}
      >{`${firstName} ${lastName}`}</ModalHeader>

      <ModalBody justifyContent='center'>
        <Heading fontSize='xl'>{t('modal.member.score.sub.caption')}</Heading>

        {score ? (
          <Flex justifyContent='center' margin='0 auto' mt={{ base: 4, lg: '6vh' }} flexWrap='wrap'>
            <CardWithShadow
              w={{ base: '100%', lg: '65%' }}
              mb={{ base: 6, lg: 0 }}
              mr={{ base: 0, lg: 6 }}
              display='flex'
              justifyContent='center'
              alignItems='center'
              maxW={{ base: '450px', lg: '400px' }}
            >
              <RadarChart userResults={score} />
            </CardWithShadow>

            <VStack w={{ base: '100%', lg: '20%' }} spacing={4} maxW={{ base: '450px', lg: '250px' }}>
              {RADAR_LINES.map(({ labelKey, icon }, i) => (
                <ScoreCard key={labelKey} value={Number(score[i])} icon={icon} labelKey={labelKey} p={3} />
              ))}
            </VStack>
          </Flex>
        ) : null}
      </ModalBody>

      <ModalFooter>
        <Box w={{ base: 50, lg: 55 }}>
          <RippleBackBtn onClick={onClose} width='100%' />
        </Box>
      </ModalFooter>
    </BaseModal>
  );
};
